import styled from 'styled-components';
import {FormFieldContainer} from '../../../components/Form/FormStyles';

export const NumericFormFieldContainer = styled(FormFieldContainer)`
    & > input {
        max-width: 200px;
    }
`;
